import { AddressActionType } from "./action-type";

export const actionZipCodeSearch = (payload, callBack) => ({
    type: AddressActionType.ZIP_CODE_SEARCH,
    payload,
    callBack
});
